import { RacwaBreadcrumbDetails } from "@racwa/react-components";

const FRAGMENT = "#";

export enum Breadcrumb {
  MakeAClaim = "Make a claim",
  CarInsurance = "Car insurance",
  MotorGlassDamage = "Motor glass damage",
  Claim = "Claim",
}

type BreadcrumbLink = RacwaBreadcrumbDetails["links"][number];

const breadcrumbs: Record<Breadcrumb, BreadcrumbLink> = {
  [Breadcrumb.MakeAClaim]: {
    name: Breadcrumb.MakeAClaim,
    key: Breadcrumb.MakeAClaim,
    href: process.env.REACT_APP_RAC_MAKE_A_CLAIM_PAGE ?? FRAGMENT,
  },
  [Breadcrumb.CarInsurance]: {
    name: Breadcrumb.CarInsurance,
    key: Breadcrumb.CarInsurance,
    href: process.env.REACT_APP_SPARK_TRIAGE_CAR_INSURANCE_URL ?? FRAGMENT,
  },
  [Breadcrumb.MotorGlassDamage]: {
    name: Breadcrumb.MotorGlassDamage,
    key: Breadcrumb.MotorGlassDamage,
    href: process.env.REACT_APP_BASE_URL ?? FRAGMENT,
  },
  [Breadcrumb.Claim]: {
    name: Breadcrumb.Claim,
    key: Breadcrumb.Claim,
    href: FRAGMENT,
  },
};

export const getBreadcrumbs = (isActiveFlow: boolean): RacwaBreadcrumbDetails => {
  const links = [breadcrumbs[Breadcrumb.MakeAClaim], breadcrumbs[Breadcrumb.CarInsurance]];

  let currentPage: RacwaBreadcrumbDetails["currentPage"];
  if (isActiveFlow) {
    links.push(breadcrumbs[Breadcrumb.MotorGlassDamage]);
    currentPage = breadcrumbs[Breadcrumb.Claim];
  } else {
    currentPage = breadcrumbs[Breadcrumb.MotorGlassDamage];
  }

  return {
    links,
    currentPage,
  };
};

export default getBreadcrumbs;
